/** @jsx jsx */
import { jsx } from "theme-ui"

import Button from "../Button"

import { ReactComponent as GlobeIcon } from "../../../images/icons/globe.svg"
import { ReactComponent as ListIcon } from "../../../images/icons/grid.svg"

const ViewSwitcher = ({ forwardedSx, view, onViewChange }) => {
  return (
    <div
      sx={{
        display: "flex",
        bg: "background",
        boxShadow: "cardSmall",
        borderRadius: "2em",
        color: "gray",
        py: 1,
        px: "3px",
        alignSelf: "center",
        "> *": {
          mx: 1,
        },
        ...forwardedSx,
      }}
    >
      <Button
        variant="reset"
        sx={{ color: view === "globe" && "primary" }}
        onClick={() => onViewChange("globe")}
      >
        <GlobeIcon width={35} height={35} />
      </Button>
      <Button
        variant="reset"
        sx={{ color: view === "list" && "primary" }}
        onClick={() => onViewChange("list")}
      >
        <ListIcon width={30} height={24} />
      </Button>
    </div>
  )
}

export default ViewSwitcher
